import { Injectable } from '@angular/core';
import {RestApiService} from '../../../shared/services/rest-api.service';
import {CalculationService} from './calculation.service';
import {ConfigurationService} from './configuration/configuration.service';
import {ProcessRequest} from '../../models/process-request.model';
import {ApiParamsService} from '../api-params.service';
import {ApiRequestKey} from '../../../shared/enums/api-request-key.enum';

@Injectable({
  providedIn: 'root'
})
export class DraftOfferApiService {

  private readonly API_REQUEST_KEY: ApiRequestKey = ApiRequestKey.DRAFT_OFFER;

  get postDraftOfferAllowed(): boolean {
    return this.calculationService.isRegistrationNumberValid && this.calculationService.isBirthDateValid;
  }

  constructor(private api: RestApiService,
              private calculationService: CalculationService,
              private configurationService: ConfigurationService,
              private apiParamsService: ApiParamsService) { }

  postDraftOffer(): Promise<void> {
    const req: ProcessRequest = {
      header: {
        processContext: {
          businessParameters: this.apiParamsService.createBusinessParams({
            requestKey: this.API_REQUEST_KEY
          })
        }
      },
      body: {
        calculationData: {
          vehicle: {
            registrationNumber: this.calculationService.calculationData.vehicle.registrationNumber
          },
          owner: {
            birthDate: this.calculationService.calculationData.owner.birthDate
          }
        }
      }
    }

    return this.api.post(this.configurationService.configuration.uiConfig.draftOfferEndpoint, req);
  }
}
